import styled, { DefaultTheme } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
  width: 100%;
`;

export const StyledHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

export const StyledTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
  margin-bottom: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
`;

export const StyledCloseIconWrapper = styled.div`
  cursor: pointer;

  & * {
    cursor: pointer;
  }
`;

export const StyledButton = styled.button<{ theme: DefaultTheme }>`
  all: unset;
  cursor: pointer;
  border-style: dashed;
  pointer-events: all;
  flex-grow: 1;
  border-color: ${({ theme }) => theme.Color.Overlay.Light};
  border-width: ${({ theme }) => utils.rem(theme.Border.Size.Small)};
  border-radius: ${({ theme }) => utils.rem(theme.Border.Radius.Small)};
  max-width: ${({ theme }) => utils.rem(theme.Spacing.Size.XLarge)};
  height: ${({ theme }) => utils.rem(theme.Spacing.Size.XLarge)};
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: ${({ theme }) => theme.Screen.Size.Small}px) {
    max-width: unset;

    &:hover {
      background-color: ${({ theme }) => theme.Color.System.Lightest};
      border-color: ${({ theme }) => theme.Color.Brand.Primary};

      svg {
        align-self: center;
      }
    }
  }
`;

export const StyledColorBulletWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XXSmall)};
  flex-wrap: wrap;
  max-width: 100%;
  min-height: fit-content;

  & .color-bullet-wrapper {
    height: ${({ theme }) => utils.rem(theme.Spacing.Size.XLarge)};
    width: ${({ theme }) => utils.rem(theme.Spacing.Size.XLarge)};
  }
  & .color-bullet {
    height: ${({ theme }) => utils.rem(theme.Spacing.Size.XLarge)};
    width: ${({ theme }) => utils.rem(theme.Spacing.Size.XLarge)};
  }

  @media (min-width: ${({ theme }) => theme.Screen.Size.Small}px) {
    height: fit-content;
    flex-wrap: nowrap;
    max-width: 100%;

    min-height: ${({ theme }) => utils.rem(theme.Spacing.Size.XLarge)};
    height: fit-content;
    & .color-bullet-wrapper {
      flex-grow: 1;
      min-width: ${({ theme }) => utils.rem(theme.Spacing.Size.XLarge)};
    }
    & .color-bullet {
      flex-grow: 1;
      width: 100%;
    }
  }
`;

export const StyledColorInputWrapper = styled.div`
  width: 100%;
  margin-left: ${({ theme }) => utils.rem(theme.Spacing.Size.XXSmall)};
`;

export const StyledEditableTextContainer = styled.div`
  min-height: ${({ theme }) => utils.rem(theme.Spacing.Size.XLarge)};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export const StyledDashedDivider = styled.div`
  ${({ theme }) => `
    height: ${utils.rem(theme.Border.Size.Small)};
    width: 100%;
    margin-top: ${utils.rem(theme.Spacing.Size.XXSmall)};
    border-top: ${utils.rem(theme.Border.Size.Small)} solid ${theme.Color.Neutrals.Border};
    border-image: repeating-linear-gradient(
        to right,
        ${theme.Color.Neutrals.Border},
        ${theme.Color.Neutrals.Border} ${utils.rem(theme.Spacing.Size.XSmall)},
        transparent ${utils.rem(theme.Spacing.Size.XSmall)},
        transparent ${utils.rem(theme.Spacing.Size.MediumSmall)}
      )
      1 / 1 / 0 stretch;
  `}
`;

export const StyledColorName = styled.span`
  ${utils.getFontStyle('Small')};
  color: ${({ theme }) => theme.Color.Neutrals.Dark};
`;

export const StyledColorDetailsWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
  padding: ${({ theme }) => utils.rem(theme.Spacing.Small)} 0;
`;

export const StyledColorNameAndPreviewWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
`;

export const StyledColorBulletPickerWrapper = styled.div`
  height: ${({ theme }) => utils.rem(theme.Spacing.Size.XLarge)};
  width: ${({ theme }) => utils.rem(theme.Spacing.Size.XLarge)};

  & * {
    width: 100%;
    height: 100%;
  }
`;

export const StyledDeleteButton = styled.div`
  align-self: center;
  pointer-events: all;
  cursor: pointer;
`;

export const StyledControlsWrapper = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: row;
  margin-top: ${({ theme }) => utils.rem(theme.Spacing.Size.Small)};
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
  margin-left: ${({ isMobile }) => (isMobile ? 'unset' : 'auto')};
`;
